import React from 'react'
import { isInFlyinDomain } from 'AccountsUtils'
import FacebookIcon from './icons/facebook.svg'
import TwitterIcon from './icons/twitter.svg'

const Footer = () => {
  return (
    isInFlyinDomain() ? <></> : (
      <footer>
        <div className="container bt">
          <div className="pt-3 pb-3">
            <nav className="flex flex-between">
              <ul className="fs-caption-2 flex c-blue">
                <li className="c-blue">
                  <a href="/" title="Home">
                  Home
                  </a>
                </li>
                <li className="ml-3 c-blue">
                  <a href="/about" title="About Us">
                  About Us
                  </a>
                </li>
                <li className="ml-3 c-blue">
                  <a href="/faq" title="FAQs">
                  FAQs
                  </a>
                </li>
                <li className="ml-3 c-blue">
                  <a href="/support" title="Support">
                  Support
                  </a>
                </li>
                <li className="ml-3 c-blue">
                  <a href="http://www.cleartrip.com/giftcards">Gift Cards</a>
                </li>
              </ul>
              <ul className="flex fs-caption-2 c-grey-20">
                <span className="mr-8 fw-600 fs-caption-2">Connect</span>
                <a href="http://facebook.com/cleartrip">
                  <FacebookIcon
                    width="16"
                    height="16"
                    className="flex flex-column flex-bottom current-fill c-grey-20 mr-8"
                  />
                </a>
                <a href="http://twitter.com/cleartrip">
                  <TwitterIcon
                    width="16"
                    height="16"
                    className="flex flex-column flex-bottom  current-fill c-grey-20 mr-8"
                  />
                </a>
              </ul>
            </nav>

            <ul className="fs-11 flex pt-1 c-grey-40">
              <li className="c-grey-40">{`© 2006–${new Date().getFullYear()} Cleartrip Pvt. Ltd.`}</li>
              <li className="ml-3 c-grey-40">
                <a className="c-grey-40" href="/privacy" title="Privacy">
                Privacy
                </a>
              </li>
              <li className="ml-3 c-grey-40">
                <a className="c-grey-40" href="/security" title="Security">
                Security
                </a>
              </li>
              <li className="ml-3 c-grey-40">
                <a className="c-grey-40" href="/terms" title="Terms of Use">
                Terms of Use
                </a>
              </li>
              <li className="ml-3 c-grey-40">
                <a className="c-grey-40" href="/grievance" title="Grievance Redressal">
                Grievance Redressal
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    ))
}

export default Footer
